import { Navigate, Route, Routes } from "react-router-dom";
import {
  All,
  Contracts,
  Customers,
  Dashboard,
  Insurances,
  Locations,
  UnitDescription,
  Sync,
  UnitDescriptionSetup,
  WebsiteGraphics,
  GalleryView,
  UnitSizes,
  UnitCategory,
} from "@pages";
import { AdminLayout } from "@components";
import { ROUTES } from "./routes";

export const AuthenticatedNavigator = () => {
  return (
    <Routes>
      <Route path={ROUTES.ADMIN} element={<AdminLayout />}>
        <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
        <Route path={ROUTES.LOCATIONS} element={<Locations />} />
        <Route path={ROUTES.UNITS}>
          <Route path={ROUTES.ALL} element={<All />} />
        </Route>
        <Route path={ROUTES.CUSTOMERS} element={<Customers />} />
        <Route path={ROUTES.CONTRACTS} element={<Contracts />} />
        <Route path={ROUTES.INSURANCES} element={<Insurances />} />
        <Route path={ROUTES.WEBSITE_SETTINGS}>
          <Route
            path={ROUTES.WEBSITE_UNIT_DESCRIPTIONS}
            element={<UnitDescriptionSetup />}
          />
          <Route path={ROUTES.UNITDESCRIPTION} element={<UnitDescription />} />
          <Route path={ROUTES.UNITSIZES} element={<UnitSizes />} />
          <Route path={ROUTES.UNITCATEGORY} element={<UnitCategory />} />
          <Route path={ROUTES.WEBSITE_GRAPHICS}>
            <Route index element={<WebsiteGraphics />} />

            <Route path=":type" element={<GalleryView />} />
          </Route>
          <Route path={ROUTES.SYNC} element={<Sync />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />

      <Route
        path="/admin"
        element={<Navigate to="/admin/dashboard" replace />}
      />
    </Routes>
  );
};
